import React from "react";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import { createRoot, hydrateRoot } from "react-dom/client";
import Root from "./Root";
import { loadGTMOnce } from "./shared/utils/gtm";

const rootElement = document.getElementById("root");
const pageType = window.pageType;

loadGTMOnce();

function Main() {
  return (
    <BrowserRouter>
      <Root pageType={pageType} />
    </BrowserRouter>
  );
}

if (rootElement?.dataset?.ssr === "true") {
  hydrateRoot(rootElement, <Main />);
} else {
  createRoot(rootElement).render(<Main />);
}
